import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'

@Injectable({ providedIn: 'root' })
export class TransactionDetailsModalService {
    private readonly _hidden = new BehaviorSubject<boolean>(true)
    private readonly _transactionId = new BehaviorSubject<string | null>(null)
    private readonly _sessionId = new BehaviorSubject<string | null>(null)

    readonly hidden$ = this._hidden.asObservable()
    readonly transactionId$ = this._transactionId.asObservable()
    readonly sessionId$ = this._sessionId.asObservable()

    get hidden(): BehaviorSubject<boolean> {
        return this._hidden
    }

    get isHidden(): boolean {
        return this._hidden.getValue()
    }

    get sessionId(): string | null {
        return this._sessionId.getValue()
    }

    open(transactionId: string, sessionId: string): void {
        this._transactionId.next(transactionId)
        this._sessionId.next(sessionId)
        this._hidden.next(false)
    }

    close(): void {
        this._transactionId.next(null)
        this._sessionId.next(null)
        this._hidden.next(true)
    }
}
